export default __webpack_public_path__ + "static/media/buttons-card-3.656bb2f5.svg";